module.exports = __webpack_public_path__ + "static/media/boxeo.37beb0bc.webp";